import {
  AuctionViewing,
  LegacyDateValue,
} from '@bonhams1793/bonhams-typescript'

export const auctionViewingsAuctionListMapper = (
  auctionViewings: AuctionViewing[]
): {
  entity: AuctionViewing['auction']
  viewingDays: { id: number; start: LegacyDateValue; end: LegacyDateValue }[]
}[] => {
  return [
    ...new Map(
      auctionViewings.map(({ auction }, _, originalViewings) => [
        auction.id,
        {
          entity: auction,
          viewingDays: originalViewings
            .filter((viewing) => auction.id === viewing.auction.id)
            .map(({ id, dates }) => ({ id, ...dates })),
        },
      ])
    ).values(),
  ]
}

type AuctionViewingWithLocation = AuctionViewing & {
  location: NonNullable<AuctionViewing['location']>
}

export const auctionViewingsLocationListMapper = (
  auctionViewings: AuctionViewing[]
): {
  entity: NonNullable<AuctionViewing['location']>
  viewingDays: { id: number; start: LegacyDateValue; end: LegacyDateValue }[]
}[] => {
  const hasLocation = (
    auctionViewing: AuctionViewing
  ): auctionViewing is AuctionViewingWithLocation => {
    return 'location' in auctionViewing && !!auctionViewing.location
  }

  return [
    ...new Map(
      auctionViewings
        ?.filter(hasLocation)
        .map(({ location }, _, originalViewings) => [
          location.code,
          {
            entity: location,
            viewingDays: originalViewings
              .filter((viewing) => location.code === viewing.location.code)
              .map(({ id, dates }) => ({ id, ...dates })),
          },
        ])
    ).values(),
  ]
}
